/* KiiDS.SHOP Kolotoč 2.0 motion layer. No libraries; every effect has a static end state.
   Levels (theme setting, html[data-kiids-motion]): full = all, gentle = reveal + fly-to-cart (with confetti), none = nothing.
   prefers-reduced-motion and the "Menej pohybu" toggle ([data-kiids-still-toggle]) always switch everything off. */
(() => {
  const root = document.documentElement;
  const STILL_KEY = 'kiids-still';
  const PAUSE_KEY = 'kiids-paused';
  const reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');
  const fineMq = window.matchMedia('(hover: hover) and (pointer: fine)');

  const readStill = () => { try { return localStorage.getItem(STILL_KEY) === '1'; } catch (e) { return false; } };
  let userStill = readStill();
  let userPaused = (() => { try { return localStorage.getItem(PAUSE_KEY) === '1'; } catch (e) { return false; } })();

  const level = () => {
    if (reduceMq.matches || userStill) return 'none';
    const v = root.dataset.kiidsMotion;
    return v === 'gentle' || v === 'none' ? v : 'full';
  };
  const on = (fx) => {
    const l = level();
    return l === 'full' || (l === 'gentle' && (fx === 'reveal' || fx === 'fly'));
  };
  const sync = () => {
    root.classList.toggle('kiids-still', level() === 'none');
    root.classList.toggle('kiids-paused', userPaused);
    document.querySelectorAll('[data-kiids-still-toggle]').forEach((b) => b.setAttribute('aria-pressed', String(userStill)));
    document.querySelectorAll('[data-kiids-pause-toggle]').forEach((b) => b.setAttribute('aria-pressed', String(userPaused)));
    document.dispatchEvent(new CustomEvent('kiids:motion', { detail: { level: level(), paused: userPaused } }));
  };
  // Shared with section scripts (kiids-kolotoc.js): same levels, same off switches. Pause stops loops only.
  window.kiidsMotion = { on, level, paused: () => userPaused };

  root.classList.add('kiids-js');
  sync();
  reduceMq.addEventListener('change', sync);

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-kiids-still-toggle]')) {
      userStill = !userStill;
      try { localStorage.setItem(STILL_KEY, userStill ? '1' : '0'); } catch (err) {}
      sync();
    } else if (e.target.closest('[data-kiids-pause-toggle]')) {
      userPaused = !userPaused;
      try { localStorage.setItem(PAUSE_KEY, userPaused ? '1' : '0'); } catch (err) {}
      sync();
    }
  });

  // 1 · reveal on scroll, once. Without IntersectionObserver everything stays visible.
  const reveal = (scope) => {
    const els = scope.querySelectorAll('.kiids-rv:not(.is-on)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || !on('reveal')) { els.forEach((el) => el.classList.add('is-on')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-on');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    els.forEach((el) => io.observe(el));
  };

  // 7 · count-up, once when visible: <span data-kiids-count="4.76" data-decimals="2">4,76</span>
  const fmt = (n, d) => n.toLocaleString(root.lang || undefined, { minimumFractionDigits: d, maximumFractionDigits: d });
  const countUp = (el) => {
    const to = parseFloat(el.dataset.kiidsCount);
    const d = parseInt(el.dataset.decimals || '0', 10);
    if (isNaN(to) || !on('count')) return;
    const t0 = performance.now(), dur = 950;
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / dur);
      el.textContent = fmt(to * (1 - Math.pow(1 - p, 3)), d);
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };
  const counters = (scope) => {
    const els = scope.querySelectorAll('[data-kiids-count]:not([data-counted])');
    if (!els.length || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        en.target.setAttribute('data-counted', '');
        countUp(en.target);
        io.unobserve(en.target);
      });
    }, { threshold: 0.5 });
    els.forEach((el) => io.observe(el));
  };

  // 3 · marquee speed follows scroll velocity; one passive listener, rAF-throttled.
  const mq = { rate: 1, target: 1, kick: 0, loop: false };
  const setRate = (r) => {
    document.querySelectorAll('.kiids-track').forEach((el) => {
      el.getAnimations().forEach((a) => { a.playbackRate = r; });
    });
  };
  const mqStep = () => {
    if (!on('marquee')) { mq.rate = 1; setRate(1); mq.loop = false; return; }
    const tgt = performance.now() - mq.kick > 160 ? 1 : mq.target;
    mq.rate += (tgt - mq.rate) * 0.1;
    if (tgt === 1 && Math.abs(1 - mq.rate) < 0.01) { mq.rate = 1; setRate(1); mq.loop = false; return; }
    setRate(mq.rate);
    requestAnimationFrame(mqStep);
  };
  let lastY = window.scrollY, lastT = performance.now(), pending = false;
  window.addEventListener('scroll', () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      const y = window.scrollY, t = performance.now();
      const v = (y - lastY) / Math.max(8, t - lastT);
      lastY = y; lastT = t;
      if (!v || !on('marquee') || !document.querySelector('.kiids-track')) return;
      mq.target = (v < 0 ? -1 : 1) * (1 + Math.min(5, Math.abs(v) * 2.5));
      mq.kick = t;
      if (!mq.loop) { mq.loop = true; requestAnimationFrame(mqStep); }
    });
  }, { passive: true });

  // 4 · tilt toward cursor (max 6°) and 8 · magnetic CTA (max 6 px): mouse only.
  document.addEventListener('pointermove', (e) => {
    if (e.pointerType !== 'mouse' || !fineMq.matches) return;
    const tilt = e.target.closest('.kiids-tilt');
    if (tilt && on('tilt')) {
      const r = tilt.getBoundingClientRect();
      const q = (v) => Math.max(-2, Math.min(2, Math.round(v * 4))) * 3;
      tilt.style.setProperty('--kiids-ry', q((e.clientX - r.left) / r.width - 0.5) + 'deg');
      tilt.style.setProperty('--kiids-rx', -q((e.clientY - r.top) / r.height - 0.5) + 'deg');
    }
    const mag = e.target.closest('[data-kiids-magnetic]');
    if (mag && on('mag')) {
      const r = mag.getBoundingClientRect();
      const q = (v) => Math.max(-3, Math.min(3, Math.round(v * 3))) * 2;
      mag.style.setProperty('--kiids-mx', q((e.clientX - r.left) / r.width * 2 - 1) + 'px');
      mag.style.setProperty('--kiids-my', q((e.clientY - r.top) / r.height * 2 - 1) / 2 + 'px');
    }
  }, { passive: true });
  document.addEventListener('pointerout', (e) => {
    const el = e.target.closest('.kiids-tilt, [data-kiids-magnetic]');
    if (!el || el.contains(e.relatedTarget)) return;
    ['--kiids-rx', '--kiids-ry', '--kiids-mx', '--kiids-my'].forEach((p) => el.style.removeProperty(p));
  });

  // 5 · fly-to-cart / to the heart, then badge pop. Reduced motion: no animation (Ella updates the badge itself).
  const visible = (sel) => [...document.querySelectorAll(sel)].find((el) => el.getClientRects().length);
  const pop = (el) => {
    if (!el || !on('fly')) return;
    el.classList.remove('kiids-pop');
    void el.offsetWidth;
    el.classList.add('kiids-pop');
  };
  const fly = (fromEl, toEl, kind) => {
    if (!fromEl || !toEl || !on('fly')) return pop(toEl);
    const a = fromEl.getBoundingClientRect(), b = toEl.getBoundingClientRect();
    const x = a.left + a.width / 2, y = a.top + a.height / 2;
    const s = document.createElement('span');
    s.className = 'kiids-fly' + (kind === 'wish' ? ' kiids-fly--wish' : '');
    s.setAttribute('aria-hidden', 'true');
    s.style.left = x + 'px';
    s.style.top = y + 'px';
    document.body.appendChild(s);
    requestAnimationFrame(() => requestAnimationFrame(() => {
      s.style.translate = (b.left + b.width / 2 - x) + 'px 0';
      s.style.transform = 'translateY(' + (b.top + b.height / 2 - y) + 'px) scale(.45) rotate(200deg)';
    }));
    setTimeout(() => { s.remove(); pop(toEl); }, 650);
  };

  // 10 · confetti burst from an element (heart, add button): brand colours, WAAPI, removed when done.
  const COLORS = ['#C6FF3D', '#FF5FA2', '#5c02ae', '#FFF7E8'];
  const burst = (el) => {
    if (!el || !on('fly') || !Element.prototype.animate) return;
    const r = el.getBoundingClientRect();
    for (let i = 0; i < 14; i++) {
      const c = document.createElement('span');
      c.className = 'kiids-confetti';
      c.setAttribute('aria-hidden', 'true');
      c.style.left = r.left + r.width / 2 + 'px';
      c.style.top = r.top + r.height / 2 + 'px';
      c.style.background = COLORS[i % COLORS.length];
      document.body.appendChild(c);
      const a = (i / 14) * Math.PI * 2 + Math.random() * 0.4, d = 40 + Math.random() * 50;
      c.animate([
        { transform: 'translate(0, 0) rotate(0deg)', opacity: 1 },
        { transform: `translate(${Math.cos(a) * d}px, ${Math.sin(a) * d + 30}px) rotate(${360 + Math.random() * 360}deg)`, opacity: 0 }
      ], { duration: 700 + Math.random() * 300, easing: 'cubic-bezier(.2, .7, .3, 1)' }).onfinish = () => c.remove();
    }
  };

  window.kiidsMotion.burst = burst; // also used by the collection header toys (kiids-chead.js)

  // Capture phase: Ella's wishlist handler stops propagation, and the class still shows the pre-click state here.
  let addOrigin = null, addAt = 0;
  document.addEventListener('click', (e) => {
    const wish = e.target.closest('[data-wishlist]');
    if (wish && !wish.classList.contains('wishlist-added')) {
      fly(wish, visible('.header__icon--wishlist, [data-wishlist-count]'), 'wish');
      burst(wish);
    }
    const add = e.target.closest('[name="add"], [data-kiids-add]');
    if (add) { addOrigin = add; addAt = performance.now(); }
  }, true);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
      if (!data || data.source !== 'product-form-component' || !addOrigin || performance.now() - addAt > 5000) return;
      burst(addOrigin);
      fly(addOrigin, visible('#cart-icon-bubble'), 'cart');
      addOrigin = null;
    });
  }

  // Video loops (M-HERO-01, M-RIDE-01): play only at full motion, otherwise the poster stays.
  // The MP4s (2-3 MB each) start only after window load and only while within 200px of the viewport (paused when out).
  // Without IntersectionObserver they play at once, as before.
  const near = new WeakSet(), watched = new WeakSet();
  const vio = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((en) => { if (en.isIntersecting) near.add(en.target); else near.delete(en.target); });
    videos();
  }, { rootMargin: '200px 0px' }) : null;
  let loaded = document.readyState === 'complete';
  if (!loaded) window.addEventListener('load', () => { loaded = true; videos(); });
  function videos() {
    document.querySelectorAll('video[data-kiids-video]').forEach((v) => {
      if (vio && !watched.has(v)) { watched.add(v); vio.observe(v); }
      if (on('video') && !userPaused && (!vio || (loaded && near.has(v)))) v.play().catch(() => {});
      else v.pause();
    });
  }
  document.addEventListener('kiids:motion', videos);
  // Pages opened in a background tab refuse autoplay; retry when the tab becomes visible.
  document.addEventListener('visibilitychange', () => { if (!document.hidden) videos(); });

  // 12 · scroll progress: lift it out of its section's stacking context so it sits above the sticky header.
  const progress = (scope) => scope.querySelectorAll('.kiids-progress').forEach((el) => {
    document.querySelectorAll('body > .kiids-progress').forEach((old) => old.remove());
    document.body.appendChild(el);
  });

  const init = (scope) => { reveal(scope); counters(scope); videos(); progress(scope); };
  init(document);
  // Theme editor: re-run for sections added or re-rendered.
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
